const en: Record<string, string> = {
  'features.events.addEvent': 'Add event',
  'features.events.create': 'Create',
  'features.events.editEvent': 'Edit event',
  'features.events.viewEvent': 'Event',
  'features.events.openInProject': 'Open in project',
  'features.events.title': 'Title',
  'features.events.titlePlaceholder': 'Event title...',
  'features.events.schedule': 'Date & time',
  'features.events.allDay': 'All day',
  'features.events.multiDay': 'Multi-day',
  'features.events.from': 'From',
  'features.events.to': 'To',
  'features.events.participants': 'Participants',
  'features.events.labels': 'Labels',
  'features.events.color': 'Color',
  'features.events.storyPoints': 'Story points',
  'features.events.notes': 'Notes',
  'features.events.noNotes': 'No notes yet.',
  'features.events.reminders': 'Reminders',
  'features.events.addReminder': 'Add reminder',
  'features.events.reminderNotification': 'Notification',
  'features.events.reminderMail': 'Email',
  'features.events.delete': 'Delete',
  'features.events.confirmDelete': 'Confirm delete',
  'features.events.during': 'for',
  'features.events.duration': 'Duration',
  'features.events.durationDays': '{{days}} day(s) and {{hours}} hour(s)',
  'features.events.midnight': 'Midnight',
  'features.events.noEvents': 'No events on this day.',
  'features.events.noEventsWeek': 'No events this week.',
  'features.events.switchToWeekView': 'Switch to week view',
  'features.events.switchToDayView': 'Switch to day view',
};

export default en;
